import { Link } from "react-router-dom";
import { Badge, Box, Card, Tab, Tabs } from "@mui/material";
import List from "./ListMinutes";
import { useState } from "react";
import ActionButtons from "../buttons/ActionButtons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AddIcon from "@mui/icons-material/Add";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 0 }}>{children}</Box>}
    </div>
  );
}

const MinutesListComponent = (props) => {
  const { meetings, location, systemSettings } = props;
  const [value, setValue] = useState(location?.state?.tab ?? 0);
  const mainBackground = systemSettings?.mainBackground;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const history = useHistory();
  const handleAddNewMinutes = () => {
    history.push("/admin/create-minutes");
  };

  return (
    <div className="">
      <div className="flex justify-between items-center">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item pageTitle"></li>
          </ol>
        </nav>
        <div className="row justify-content-end">
          <div className="col-md-5 flex justify-end">
            <div className={"flex-grow-1 me-2"}></div>
            <div className={"me-2"}>
              <Link to="/admin/meeting" className={"text-decoration-none"}></Link>
            </div>
            <div className="ml-2">
              <Link to="/admin/minutes" className={"text-decoration-none"}></Link>
            </div>
          </div>
        </div>
      </div>
      <Card className={"overflow-auto mt-3"} variant={"outlined"}>
        <div className={"card-body mt-0 pt-0"}>
          <div className="row group-btn">
            <div className="col-md-7"></div>
            <h1 className="ml-2 p-3 font-semibold text-sm">
              {/* Minutes List */}
            </h1>
          </div>
          
          <Box
            sx={{ borderBottom: 1, borderColor: "divider" }}
            className="flex flex-col p-3"
          >
            <div className="flex justify-end items-center"> 
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label={
                    <span className="flex items-center">
                      <AddIcon className="mr-2" />
                      Add new
                    </span>
                  }
                  {...a11yProps(2)}
                  onClick={handleAddNewMinutes}
                  sx={{
                    backgroundColor: mainBackground,
                    color: "white",
                    borderRadius: "4px",
                    padding: "8px 16px",
                    "&:hover": { backgroundColor: mainBackground },
                    "&.Mui-selected": {
                      backgroundColor:mainBackground,
                      color: "white",
                    },
                  }}
                />
              </Tabs>
            </div>
          </Box>
          <TabPanel value={value} index={0}>
            <List
            // meetings={meetings}
            // selected={selected}
            // type={"my-schedule"}
            // setSelected={setSelected}
            // GetAllMeetings={GetAllMeetings}
            // settings={settings}
            // notification={notification}
            // MarkAsRead={MarkAsRead}
            />
          </TabPanel>
        </div>
      </Card>
    </div>
  );
};

export default MinutesListComponent;